import React, { FC } from 'react'
import {
  Box,
  Flex,
  Heading,
} from '@chakra-ui/react'
import Breadcrumbs from 'src/components/Breadcrumbs'
import { PrimaryButton } from 'src/uikit'
import { Breadcrumb } from 'src/components/common/StructuredData'

interface Props {
  title: string
  incipit: string
  crumbs: Array<any>
  image?: string
  isCity?: boolean
  action?: string
  actionTitle?: string
  bgColor?: string
  target: string
}

const LandingPageHeaderContainer: FC<Props> = ({
  title,
  incipit,
  crumbs,
  image,
  isCity,
  action,
  actionTitle,
  bgColor,
  target,
}) => {
  return <Box bgColor={bgColor || 'baseWhite'}>
    <Box maxW={isCity ? `8xl` : null} mx="auto" pb={isCity ? `l` : null}>
      {!isCity ?
        <Flex display={{ base: 'none', md: 'flex' }}>
          <Breadcrumbs items={crumbs} />
        </Flex>
        :
        <Breadcrumb breadcrumbData={crumbs} />
      }
      <Box px="l" pt="0" pb="l" display={{ md: 'flex' }} gap={image ? `30px` : null} flexDirection={isCity ? `row-reverse` : `row`} tabIndex={-1}>
        <Box width={{
          base: '100%',
          md: image ? (isCity ? '50%' : '65%') : '100%'
        }} textAlign="left" m="auto">
          <Heading as="h1" fontSize="1.75rem" lineHeight="2.275rem" fontFamily="Montserrat-SemiBold" textAlign="left" pb="s" pt={{ base: 'l', md: isCity ? 'l' : '0' }}>
            {title}
          </Heading>
          <Box
            marginTop="s"
            color="baseNeutral.700"
            fontFamily="Montserrat-Medium"
            fontSize="md"
            pr="xl"
            className="landing-text"
            dangerouslySetInnerHTML={{ __html: incipit }}
          />

          {isCity &&
            <Box textAlign="left" mt="l" pb="xl" display={{ base: 'block', md: 'none' }}>
              <PrimaryButton
                action={action.toUpperCase()}
                title={actionTitle}
                width="inherit"
                onClick={() => window.location.href = `#${target}`}
              />
            </Box>
          }
        </Box>

        <Box
          width={{
            base: '100%',
            md: image ? (isCity ? '50%' : '35%') : '0'
          }}
          display={{ base: 'none', md: 'block' }}
          minHeight={isCity && image ? `250px` : null}
          mt={isCity ? `2rem` : null}
          bgImage={image ? `url(${image})` : null}
          bgPosition="center center"
          bgRepeat="no-repeat"
          backgroundSize="contain"
        />
      </Box>
    </Box >
  </Box >
}

export default LandingPageHeaderContainer
